import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import { ListItem } from 'react-toolbox';
import { sendEstimatorEmail } from 'actionCreators';
import SendEstimatorAPEmailModal from './sendEstimatorAPEmailModal';
import S from './styles';

const EstimatorAPButton = ({ user, canSendEmail, setCanSendEmailToFalse,
                             setCanSendEmailToTrue, className }) => {
  const [activeModal, setActiveModal] = useState(false);
  const { addToast } = useToasts();

  const notifySuccess = () => addToast('Email Sent', { appearance: 'success' });

  const notifyFailure = () => addToast('Must wait 10 sec between emails', { appearance: 'warning' });

  const sendEmail = (week) => {
    sendEstimatorEmail(user.employable_id, week);
    notifySuccess();
    setCanSendEmailToFalse();
    setTimeout(() => setCanSendEmailToTrue(), 10000);
  };

  const renderSendEstimatorAPEmailModal = () => {
    if (canSendEmail) setActiveModal(true);
    else notifyFailure();
  };

  const closeSendEstimatorAPEmailModal = () => setActiveModal(false);

  return (
    <div className={S.seeBtnContainer}>
      <ListItem
        key="send estimator ap email"
        value="send estimator ap email"
        itemContent={<div>Send Estimator AP Email</div>}
        onClick={renderSendEstimatorAPEmailModal}
        selectable={canSendEmail}
        className={className}
      />

      <SendEstimatorAPEmailModal
        active={activeModal === true}
        onClose={closeSendEstimatorAPEmailModal}
        sendEmail={sendEmail}
      />
    </div>);
};

EstimatorAPButton.propTypes = {
  user: PropTypes.object,
  canSendEmail: PropTypes.boolean,
  setCanSendEmailToFalse: PropTypes.func,
  setCanSendEmailToTrue: PropTypes.func,
  className: PropTypes.string,
};

export default EstimatorAPButton;



// WEBPACK FOOTER //
// ./client/app/shared/components/EstimatorAPButton/index.jsx